import React, { useCallback, useState, useEffect } from "react";
import { array, bool, func, string, object, number } from "prop-types";

import CarouselItem from "../../atoms/Carouseltem";
import Icons from "../../icons";
import CustomSlider from "../../atoms/CustomSlider";

import { useDevice } from "../../utils/react-utils";

import "./carousel.m.css";

const Carousel = ({ elements, position = {}, closeEvent, showIndex = true, currentSlide = 0, setCurrentSlide }) => {
  if (!(elements && elements.length > 0)) return null;
  const noOfElements = elements.length;

  const [showCaption, setShowCaption] = useState(true);
  const [fullScreen, setFullScreen] = useState(false);

  const { desktop } = useDevice();

  const closeCaptionHandler = useCallback(() => {
    setShowCaption((prev) => !prev);
  });

  const closeCarousel = () => {
    setCurrentSlide(0);
    exitFullscreenWindow();
    closeEvent();
  };

  useEffect(() => {
    document.body.style.overflowY = "hidden";
    document.addEventListener("fullscreenchange", () => {
      if (document.fullscreenElement) {
        setFullScreen(true);
      } else {
        setFullScreen(false);
      }
    });

    const popState = () => {
      exitFullscreenWindow();
      closeEvent();
    };

    window.addEventListener("popstate", popState);

    const keyup = (e) => {
      const code = e.keyCode;
      if ((code === 39 || code === 38) && currentSlide < noOfElements - 1) {
        setCurrentSlide(currentSlide + 1);
      } else if ((code === 37 || code === 40) && currentSlide >= 1) {
        setCurrentSlide(currentSlide - 1);
      }
    };
    window.addEventListener("keyup", keyup);

    return () => {
      document.body.style.overflowY = "auto";
      window.removeEventListener("popstate", popState);
      window.removeEventListener("keyup", keyup);
    };
  }, [currentSlide]);

  const exitFullscreenWindow = () => {
    if (document.fullscreenElement) {
      document
        .exitFullscreen()
        .then(() => {})
        .catch((err) => console.error(err));
    }
  };

  const makeFullScreen = () => {
    const isFullScreen = document.fullscreenElement;
    if (isFullScreen) exitFullscreenWindow();
    else document.documentElement.requestFullscreen();
  };

  const children = elements.map((item, index) => (
    <CarouselItem
      showCaption={!fullScreen && showCaption}
      clickImage={closeCaptionHandler}
      key={index}
      element={item}
      widths={[global?.window?.innerWidth]}
    />
  ));

  return (
    <div styleName={`base ${fullScreen ? "full-screen" : ""}`} style={position}>
      <div styleName="scroll-snap">
        {showCaption && (
          <div styleName="icons">
            <Icons
              type={fullScreen ? "fullscreen-exit" : "fullscreen"}
              onClick={makeFullScreen}
              styleName="full-screen-icon"
            />
            <Icons styleName="white-close-icon" type="close-white" onClick={closeCarousel} className="close" />
          </div>
        )}

        <CustomSlider
          isPopup={true}
          hideDisableIcon={true}
          isPagination={false}
          showSlideNumber={showIndex}
          isNavigation={noOfElements > 1 && desktop}
          allowTouchMove={noOfElements > 1}
          slidesPerView={{ mobileSlides: 1, tabSlides: 1, desktopSlides: 1 }}
          spacing={{ mobileSpace: 12, tabSpace: 12, desktopSpace: 12 }}
          currentSlide={currentSlide}
          setCurrentSlide={setCurrentSlide}
        >
          {children}
        </CustomSlider>
      </div>
    </div>
  );
};

Carousel.propTypes = {
  elements: array,
  lang: string,
  position: object,
  closeEvent: func,
  showIndex: bool,
  currentSlide: number,
  setCurrentSlide: func,
};

export default Carousel;
